import { CITIES } from '../../domain/repo/types/CityConfig';
import { PartnerCity } from '../../domain/repo/types/PartnerCity';
import { PartnerVehicle } from '../../domain/repo/types/PartnerVehicle';
import { SelectOption } from '../../types';

export function partnerCityToSelectConv(city: PartnerCity): SelectOption {
  return {
    key: String(city.id),
    value: city.name,
    text: city.name.toUpperCase(),
  };
}

export function partnerVehicleToSelectConv(vehicle: PartnerVehicle): SelectOption {
  return {
    key: String(vehicle.id),
    value: vehicle.name,
    text: vehicle.name.toUpperCase(),
  };
}

function snakeCaseToTitleCase(str: string): string {
  return str
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function infoSourceToSelectConv(source: string): SelectOption {
  return {
    key: source,
    value: source,
    text: snakeCaseToTitleCase(source).toUpperCase(),
  };
}

export function getKeyFromSelectOrBlank(selectItem?: SelectOption): string {
  return selectItem?.key ?? '';
}

export function getInfoSourceList(): string[] {
  return [
    'bus_ads',
    'pamphlet',
    'garage_hoarding',
    'newspaper_ads',
    'driver_referral',
    'customer_referral',
    'channel_partner',
    'others',
    'fos',
    'online/facebook',
    'smart_shift',
  ];
}

export function getServicableCities(): string[] {
  return [
    CITIES.mumbai,
    CITIES.delhi_NCR,
    CITIES.bangalore,
    CITIES.hyderabad,
    CITIES.chennai,
    CITIES.ahmedabad,
    CITIES.jaipur,
    CITIES.pune,
    CITIES.kolkata,
    CITIES.surat,
    CITIES.lucknow,
    CITIES.coimbatore,
    CITIES.indore,
    CITIES.nagpur,
    CITIES.chandigarh,
    CITIES.vadodara,
    CITIES.ludhiana,
    CITIES.kochi,
    CITIES.nashik,
    CITIES.visakhapatnam,
    CITIES.kanpur,
  ];
}

export const getDefaultCity = 'dubai';
